<template>
    <div class="d-block">
        <footer id="footer">
            <div class="container">
                <h3>Ambrosia</h3>
                <p>We are a passionate team of food enthusiasts dedicated to sharing our love for culinary delights and
                    gastronomic experiences.</p>
                <div class="social-links">
                    <a href="#" class="twitter">
                        <i class="fa-brands fa-twitter" style="color: #4380e8;"></i>
                    </a>
                    <a href="#" class="facebook">
                        <i class="fa-brands fa-facebook" style="color: #005eff;"></i>
                    </a>
                    <a href="#" class="instagram">
                        <i class="fa-brands fa-instagram" style="color: #df2a2a;"></i>
                    </a>
                    <a href="#" class="google-plus">
                        <i class="fa-brands fa-google-plus-g" style="color: #e2db18;"></i>
                    </a>
                    <a href="#" class="linkedin">

                        <i class=" fa-brands fa-linkedin" style="color: #1968f0;"></i>
                    </a>
                </div>
                <div class="copyright">
                    &copy; Copyright
                    2023 <strong><span>Ambrosia</span></strong> Restaurant Website. All rights reserved. | Developed by <a
                        href="https://www.pyaesonenyein.com/">Pyae Sone</a>
                </div>

            </div>
        </footer>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped></style>
